import { render, staticRenderFns } from "./coreProductInfoPhone.vue?vue&type=template&id=53150300&scoped=true"
import script from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
export * from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
import style0 from "./coreProductInfoPhone.vue?vue&type=style&index=0&id=53150300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53150300",
  null
  
)

export default component.exports